import React from 'react'
import propTypes from 'prop-types'
import Icon, {iconNames} from 'components/icon'
import './email.scss'

const Email = ({ email }) => (
  <a
    className="email-container"
    href={`mailto:${email}`}
    target={"_blank"}
    rel={"noopener noreferrer"}>
    <Icon name={iconNames.email} size={14} />
    {email}
  </a>
)

Email.propTypes = {
  email: propTypes.string,
}

export default Email